import { Button, ButtonProps, FormButtons } from '../Base';
import { StageConfig } from './types';

type StageButtonsProps = {
  prevStage?: StageConfig;
  nextStage?: StageConfig;
  goToStage: (stage: StageConfig) => void;
  prevProps: Partial<ButtonProps>;
  nextProps: Partial<ButtonProps>;
  nextIsLast?: boolean;
  isSubmitting?: boolean;
};

const StageButtons = ({
  prevStage,
  nextStage,
  goToStage,
  prevProps = {},
  nextProps = {},
  nextIsLast = false,
  isSubmitting = false,
}: StageButtonsProps) => {
  const tNextProps: ButtonProps | undefined =
    (nextStage && {
      type: 'button',
      children: isSubmitting
        ? 'Loading…'
        : nextStage.submitText || `Next (${nextStage.name})`,
      className: nextIsLast ? 'btn-convert' : '',
      primary: true,
      onClick: () => goToStage(nextStage),
      disabled: isSubmitting,
    }) ||
    undefined;

  const tPrevProps: ButtonProps | undefined =
    (prevStage && {
      type: 'button',
      children: `Go back to ${prevStage.name.toLowerCase()}`,
      className: 'btn-minimal',
      onClick: () => goToStage(prevStage),
      disabled: isSubmitting,
    }) ||
    undefined;

  return (
    <FormButtons reverse={!!nextStage}>
      {nextStage && (
        // @ts-ignore
        <Button {...tNextProps} {...nextProps} />
      )}
      {prevStage && (
        // @ts-ignore
        <Button {...tPrevProps} {...prevProps} />
      )}
    </FormButtons>
  );
};

export default StageButtons;
